interface MaskInput {
  unmask(): string;
  mask(): string;
}

export function normalizeCpfOrCnpj(value: string): string {
  return (value.match(/[0-9A-Za-z]/g) || []).join("").toUpperCase();
}

export function cellphoneMask(value: string): MaskInput {
  const cleanValue = value.replace(/\D/g, "");

  return {
    unmask: () => cleanValue,
    mask: () => cleanValue
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d{1,4})/, "$1-$2"),
  };
}

export function cpfMask(value: string): MaskInput {
  const cleanValue = value.replace(/\D/g, "");

  return {
    unmask: () => cleanValue,
    mask: () => cleanValue
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2"),
  };
}

export function cpfOrCnpjMask(value: string): MaskInput {
  const strFrom = 0;
  const cpfLength = 11;
  const cnpjLength = 14;
  const cleanValue = normalizeCpfOrCnpj(value);
  const isCnpj = cleanValue.length > cpfLength || /[A-Z]/.test(cleanValue);

  if (!isCnpj) {
    return {
      unmask: (): string => cleanValue,
      mask: (): string => cleanValue
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2"),
    };
  }
  const cnpjBaseLength = 12;
  const cnpjCheckDigitsLength = 2;
  const cnpjValue = cleanValue.substr(strFrom, cnpjBaseLength) +
    cleanValue.substr(cnpjBaseLength).replace(/\D/g, "").substr(strFrom, cnpjCheckDigitsLength);

  return {
    unmask: () => cnpjValue.substr(strFrom, cnpjLength),
    mask: () => cnpjValue.substr(strFrom, cnpjLength)
      .replace(/([0-9A-Z]{2})([0-9A-Z])/, "$1.$2")
      .replace(/([0-9A-Z]{3})([0-9A-Z])/, "$1.$2")
      .replace(/([0-9A-Z]{3})([0-9A-Z])/, "$1/$2")
      .replace(/([0-9A-Z]{4})(\d{1,2})/, "$1-$2"),
  };
}

export function onlyAlphanumeric(value: string): MaskInput {
  const cleanValue = value.replace(/\W/g, "");

  return {
    unmask: () => cleanValue,
    mask: () => cleanValue,
  };
}

export function zipCodeMask(value: string): MaskInput {
  const cleanValue = value.replace(/\D/g, "");

  return {
    unmask: () => cleanValue,
    mask: () => cleanValue
      .replace(/(\d{2}[.\s]?)/, "$1.")
      .replace(/(\d{3}[-.\s]?)/, "$1-")
      .replace(/(\d{3})/, "$1"),

  };
}
